import styled from 'styled-components';

export const TableContainer = styled.div`
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: auto;
  display: block;
  width: 100%;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
  padding-bottom: 3rem;
`;

export const Actions = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
`;

export const ActionButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;

  img {
    width: 20px;
    height: 20px;
  }
`;

export const PageContainer = styled.div`
  padding: 16px;
  background-color: #f5f5f5;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  background-color: white;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
`;

export const Title = styled.h1`
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  margin-left: 32px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
`;

export const FilterButton = styled.button`
  background-color: white;
  border: 1px solid #009DFF;
  color: #009DFF;
  padding: 8px 16px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;

  img {
    width: 16px;
    height: 16px;
  }
`;

export const NewProductButton = styled.button`
  background-color: #009DFF;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;

  img {
    width: 16px;
    height: 16px;
  }
`;
